import { DIMENSIONALITY_VALUES } from 'constants/businessTool';

import {
  CURRENT_ASSETS_NAMES,
  INITIAL_ASSETS_NAMES,
  NON_CURRENT_ASSETS_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialAssetsForm/utils/form';
import {
  CURRENT_LIABILITIES_NAMES,
  INITIAL_LIABILITIES_NAMES,
  NON_CURRENT_LIABILITIES_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/InitialLiabilitiesForm/utils/form';
import { OPENING_BALANCE_SHEETS_TABS_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/OpeningBalanceSheets/utils/form';
import {
  ASSETS_FORM_NAMES,
  CURRENT_ASSETS_TABLE_TOTAL_NAMES,
  NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/Sections/Assets/utils/form';
import {
  CURRENT_LIABILITIES_TABLE_NAMES,
  EQUITY_TABLE_NAMES,
  LIABILITIES_AND_EQUITY_FORM_NAMES,
  NON_CURRENT_LIABILITIES_TABLE_NAMES,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/Sections/LiabilitiesAndEquity/utils/form';
import {
  assetsPrefix,
  liabilitiesAndEquityPrefix,
} from 'components/BusinessToolForm/Sections/FinancialPlan/ProjectedBalanceSheets/utils/form';

import { concatWithDot } from 'helpers/string';

import { NestedObject } from '../../hooks/types';

const [
  shortTermDebtFieldName,
  currentPortionLongTermDebtFieldName,
  accruedLiabilitiesFieldName,
  deferredRevenueFieldName,
  deferredTaxLiabilitiesFieldName,
  provisionsFieldName,
  otherCurrentLiabilitiesFieldName,
  deferredTaxLiabilitiesNotCurrentFieldName,
  pensionLiabilitiesFieldName,
  provisionsNonCurrentFieldName,
  otherNonCurrentLiabilitiesFieldName,
  shortTermInvestmentsFieldName,
  prepaidExpensesFieldName,
  otherCurrentAssetsFieldName,
  rightOfUseAssetsFieldName,
  goodWillFieldName,
  deferredTaxAssetsName,
  otherNonCurrentAssetsFieldName,
  reservesFieldName,
  accumulatedOtherComprehensiveIncomeFieldName,
  additionalPaidInCapitalFieldName
] = [
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.SHORT_TERM_DEBT,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.CURRENT_PORTION_OF_LONG_TERM_DEBT,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.ACCRUED_LIABILITIES,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_REVENUE,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_TAX_LIABILITIES,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.PROVISIONS,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.CURRENT_LIABILITIES_TABLE,
    CURRENT_LIABILITIES_TABLE_NAMES.OTHER_CURRENT_LIABILITIES,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE,
    NON_CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_TAX_LIABILITIES,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE,
    NON_CURRENT_LIABILITIES_TABLE_NAMES.PENSION_LIABILITIES,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE,
    NON_CURRENT_LIABILITIES_TABLE_NAMES.PROVISIONS_NON_CURRENT,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE,
    NON_CURRENT_LIABILITIES_TABLE_NAMES.OTHER_NON_CURRENT_LIABILITIES,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE,
    CURRENT_ASSETS_TABLE_TOTAL_NAMES.SHORT_TERM_INVESTMENTS,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE,
    CURRENT_ASSETS_TABLE_TOTAL_NAMES.PREPAID_EXPENSES,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE,
    CURRENT_ASSETS_TABLE_TOTAL_NAMES.OTHER_CURRENT_ASSETS,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
    NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.RIGHT_OF_USE_ASSETS,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
    NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.GOODWILL,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
    NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.DEFERRED_TAX_ASSETS,
  ),
  concatWithDot(
    assetsPrefix,
    ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE,
    NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.OTHER_NON_CURRENT_ASSETS,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE,
    EQUITY_TABLE_NAMES.RESERVES,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE,
    EQUITY_TABLE_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME,
  ),
  concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.EQUITY_TABLE,
    EQUITY_TABLE_NAMES.ADDITIONAL_PAID_IN_CAPITAL,
  ),
];

export const openingBalanceSheetToProjectedBalanceSheetMap: NestedObject<string> = {
  [INITIAL_LIABILITIES_NAMES.CURRENT_LIABILITIES]: {
    [CURRENT_LIABILITIES_NAMES.SHORT_TERM_DEBT]: shortTermDebtFieldName,
    [CURRENT_LIABILITIES_NAMES.CURRENT_PORTION_LONG_TERM_DEBT]: currentPortionLongTermDebtFieldName,
    [CURRENT_LIABILITIES_NAMES.ACCRUED_LIABILITIES]: accruedLiabilitiesFieldName,
    [CURRENT_LIABILITIES_NAMES.TOTAL_DEFERRED_REVENUE]: deferredRevenueFieldName,
    [CURRENT_LIABILITIES_NAMES.DEFERRED_TAX_LIABILITIES]: deferredTaxLiabilitiesFieldName,
    [CURRENT_LIABILITIES_NAMES.PROVISIONS]: provisionsFieldName,
    [CURRENT_LIABILITIES_NAMES.OTHER_CURRENT_LIABILITIES]: otherCurrentLiabilitiesFieldName,
  },
  [INITIAL_LIABILITIES_NAMES.NON_CURRENT_LIABILITIES]: {
    [NON_CURRENT_LIABILITIES_NAMES.DEFERRED_TAX_LIABILITIES]: deferredTaxLiabilitiesNotCurrentFieldName,
    [NON_CURRENT_LIABILITIES_NAMES.TOTAL_PENSION_LIABILITIES]: pensionLiabilitiesFieldName,
    [NON_CURRENT_LIABILITIES_NAMES.PROVISIONS_NON_CURRENT]: provisionsNonCurrentFieldName,
    [NON_CURRENT_LIABILITIES_NAMES.OTHER_NON_CURRENT_LIABILITIES]: otherNonCurrentLiabilitiesFieldName,
  },
  [INITIAL_ASSETS_NAMES.CURRENT_ASSETS]: {
    [CURRENT_ASSETS_NAMES.SHORT_TERM_INVESTMENTS]: shortTermInvestmentsFieldName,
    [CURRENT_ASSETS_NAMES.PREPAID_EXPENSES]: prepaidExpensesFieldName,
    [CURRENT_ASSETS_NAMES.OTHER_CURRENT_ASSETS]: otherCurrentAssetsFieldName,
  },
  [INITIAL_ASSETS_NAMES.NON_CURRENT_ASSETS]: {
    [NON_CURRENT_ASSETS_NAMES.RIGHT_OF_USE_ASSETS]: rightOfUseAssetsFieldName,
    [NON_CURRENT_ASSETS_NAMES.GOODWILL]: goodWillFieldName,
    [NON_CURRENT_ASSETS_NAMES.DEFERRED_TAX_ASSETS]: deferredTaxAssetsName,
    [NON_CURRENT_ASSETS_NAMES.OTHER_NON_CURRENT_ASSETS]: otherNonCurrentAssetsFieldName,
  },
  [OPENING_BALANCE_SHEETS_TABS_NAMES.INITIAL_EQUITY]: {
    [EQUITY_TABLE_NAMES.RESERVES]: reservesFieldName,
    [EQUITY_TABLE_NAMES.ACCUMULATED_OTHER_COMPREHENSIVE_INCOME]: accumulatedOtherComprehensiveIncomeFieldName,
    [EQUITY_TABLE_NAMES.ADDITIONAL_PAID_IN_CAPITAL]: additionalPaidInCapitalFieldName,
  },
};

export const unitConvertorMultiplier: NestedObject<number> = {
  [DIMENSIONALITY_VALUES.SINGLE]: {
    [DIMENSIONALITY_VALUES.SINGLE]: 1,
    [DIMENSIONALITY_VALUES.THOUSAND]: 0.001,
    [DIMENSIONALITY_VALUES.MILLION]: 0.000001,
    [DIMENSIONALITY_VALUES.BILLION]: 0.000000001,
  },
  [DIMENSIONALITY_VALUES.THOUSAND]: {
    [DIMENSIONALITY_VALUES.SINGLE]: 1000,
    [DIMENSIONALITY_VALUES.MILLION]: 0.001,
    [DIMENSIONALITY_VALUES.BILLION]: 0.000001,
  },
  [DIMENSIONALITY_VALUES.MILLION]: {
    [DIMENSIONALITY_VALUES.SINGLE]: 1000000,
    [DIMENSIONALITY_VALUES.THOUSAND]: 1000,
    [DIMENSIONALITY_VALUES.BILLION]: 0.001,
  },
  [DIMENSIONALITY_VALUES.BILLION]: {
    [DIMENSIONALITY_VALUES.SINGLE]: 1000000000,
    [DIMENSIONALITY_VALUES.THOUSAND]: 1000000,
    [DIMENSIONALITY_VALUES.MILLION]: 1000,
  },
} as const;
